// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_1y9LG","loaderInX":"_1VhRn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Loader/Loader.scss
// module id = 705
// module chunks = 0